"use strict";

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParsingContext = exports.Chrono = void 0;

var results_1 = require("./results");

var en_1 = require("./locales/en");

var Chrono = /*#__PURE__*/function () {
  function Chrono(configuration) {
    _classCallCheck(this, Chrono);

    configuration = configuration || en_1.createCasualConfiguration();
    this.parsers = _toConsumableArray(configuration.parsers);
    this.refiners = _toConsumableArray(configuration.refiners);
  }

  _createClass(Chrono, [{
    key: "parseDate",
    value: function parseDate(text, refDate, opt) {
      var results = this.parse(text, refDate, opt);
      return results.length > 0 ? results[0].start.date() : null;
    }
  }, {
    key: "parse",
    value: function parse(text, refDate, opt) {
      var context = new ParsingContext(text, refDate || new Date(), opt || {});
      var results = [];
      this.parsers.forEach(function (parser) {
        var parsedResults = Chrono.executeParser(context, parser);
        results = results.concat(parsedResults);
      });
      results.sort(function (a, b) {
        return a.index - b.index;
      });
      this.refiners.forEach(function (refiner) {
        results = refiner.refine(context, results);
      });
      return results;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Chrono({
        parsers: _toConsumableArray(this.parsers),
        refiners: _toConsumableArray(this.refiners)
      });
    }
  }], [{
    key: "executeParser",
    value: function executeParser(context, parser) {
      var results = [];
      var pattern = parser.pattern(context);
      var originalText = context.text;
      var remainingText = context.text;
      var match = pattern.exec(remainingText);

      var _loop = function _loop() {
        var index = match.index + originalText.length - remainingText.length;
        match.index = index;
        var result = parser.extract(context, match);

        if (!result) {
          remainingText = originalText.substring(match.index + 1);
          match = pattern.exec(remainingText);
          return "continue";
        }

        var parsedResult = null;

        if (result instanceof results_1.ParsingResult) {
          parsedResult = result;
        } else if (result instanceof results_1.ParsingComponents) {
          parsedResult = context.createParsingResult(match.index, match[0]);
          parsedResult.start = result;
        } else {
          parsedResult = context.createParsingResult(match.index, match[0], result);
        }

        context.debug(function () {
          return console.log("".concat(parser.constructor.name, " extracted result ").concat(parsedResult));
        });
        results.push(parsedResult);
        remainingText = originalText.substring(index + parsedResult.text.length);
        match = pattern.exec(remainingText);
      };

      while (match) {
        var _ret = _loop();

        if (_ret === "continue") continue;
      }

      return results;
    }
  }]);

  return Chrono;
}();

exports.Chrono = Chrono;

var ParsingContext = /*#__PURE__*/function () {
  function ParsingContext(text, refDate, option) {
    _classCallCheck(this, ParsingContext);

    this.text = text;
    this.refDate = refDate;
    this.option = option;
  }

  _createClass(ParsingContext, [{
    key: "createParsingComponents",
    value: function createParsingComponents(components) {
      return new results_1.ParsingComponents(this.refDate, components);
    }
  }, {
    key: "createParsingResult",
    value: function createParsingResult(index, textOrEndIndex, startComponents, endComponents) {
      var text = typeof textOrEndIndex === "string" ? textOrEndIndex : this.text.substring(index, textOrEndIndex);
      var start = startComponents ? this.createParsingComponents(startComponents) : null;
      var end = endComponents ? this.createParsingComponents(endComponents) : null;
      return new results_1.ParsingResult(this.refDate, index, text, start, end);
    }
  }, {
    key: "debug",
    value: function debug(block) {
      if (this.option.debug) {
        if (this.option.debug instanceof Function) {
          this.option.debug(block);
        } else {
          var handler = this.option.debug;
          handler.debug(block);
        }
      }
    }
  }]);

  return ParsingContext;
}();

exports.ParsingContext = ParsingContext;